import React from 'react'
import './Icon.css'

const Icon = ({name, clicked, active, ...props}) =>
  <div onClick={() => clicked()} className={`Filter-Icon-Container ${active ? 'Filter-Icon-Active' : ''}`} {...props}>
    {name}
  </div>
export default Icon
